import { useEffect, useState } from "react";
import { getPublicConfig } from "../../lib/api";
import { HeartHandshake } from "lucide-react";

export function useDonationCampaign() {
  const [cfg, setCfg] = useState({ campaign_configured: false, campaign_url: null });
  useEffect(() => {
    getPublicConfig().then(setCfg).catch(() => {});
  }, []);
  return cfg;
}

export function markDonationIntent() {
  try { localStorage.setItem("mmr_donation_click", String(Date.now())); } catch {}
}

/** The single, honest JustGiving call to action. Until the official page URL
 * is configured by the administrator it renders a clearly marked setup state. */
export default function DonateButton({ className = "", children, testId = "justgiving-donate-button" }) {
  const cfg = useDonationCampaign();
  if (cfg.campaign_configured && cfg.campaign_url) {
    return (
      <a
        href={cfg.campaign_url}
        target="_blank"
        rel="noopener noreferrer"
        onClick={markDonationIntent}
        data-testid={testId}
        className={`inline-flex items-center justify-center gap-2 bg-gold text-white font-medium px-8 py-3.5 hover:bg-gold-dark transition-colors duration-300 ${className}`}
      >
        <HeartHandshake size={18} aria-hidden="true" />
        {children || "Donate via JustGiving"}
      </a>
    );
  }
  return (
    <span className={`inline-flex flex-col items-start gap-1 ${className}`} data-testid={testId}>
      <button
        type="button"
        disabled
        className="inline-flex items-center gap-2 bg-gold/60 text-white font-medium px-8 py-3.5 cursor-not-allowed"
        aria-disabled="true"
      >
        <HeartHandshake size={18} aria-hidden="true" />
        {children || "Donate via JustGiving"}
      </button>
      <span className="text-xs italic opacity-80">
        Our official JustGiving page is being set up — this button will go live once it is published.
      </span>
    </span>
  );
}
